import { Doc } from "../../common/common.model";

export class User extends Doc {
    public email                :   string;
    public lastVehicleNo        :   string;
    public addressLine1         :   string;
    public addressLine2         :   string;
    public addressLine3         :   string;
    public code                 :   string;
    public gstin                :   string;
    public mobile               :   string;
    public state                :   string;
    public name                 :   string;
    public bankAccountName      :   string;
    public bankAccountNumber    :   string;
    public bankIFSC             :   string;
    public companyPAN           :   string;

    constructor(data: any = {}) {
        console.log(data)
        super(data);
        this.email              =   data.email              || '';
        this.lastVehicleNo      =   data.lastVehicleNo      || '';
        this.addressLine1       =   data.addressLine1       || '';
        this.addressLine2       =   data.addressLine2       || '';
        this.addressLine3       =   data.addressLine3       || '';
        this.code               =   data.code               || '';
        this.gstin              =   data.gstin              || '';
        this.mobile             =   data.mobile             || '';
        this.state              =   data.state              || '';
        this.name              =   data.name                || '';
        this.bankAccountName    =   data.bankAccountName    ||  '';
        this.bankAccountNumber  =   data.bankAccountNumber  ||  '';
        this.bankIFSC           =   data.bankIFSC           ||  '';
        this.companyPAN         =   data.companyPAN         ||  '';
    }

    public toJson() {
        return {
            ...this
        };  
    }
}